import { lazy, Suspense } from "react";
import { Loader2, X } from "lucide-react";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useLocale } from "@/i18n/context";

export interface PDFPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOrderReport: () => void;
}

const SampleReportDialog = lazy(() => import("./SampleReportDialog").then(module => ({ default: module.SampleReportDialog })));

/** Keep the interactive tour and tab code off the landing page's initial path. */
export function PDFPreviewModal(props: PDFPreviewModalProps) {
  const { t } = useLocale();
  if (!props.isOpen) return null;
  return <ErrorBoundary fallback={
    <div role="alert" className="fixed bottom-5 left-[50dvw] z-[70] w-[calc(100dvw-2rem)] max-w-md -translate-x-1/2 rounded-xl border bg-background p-4 shadow-lg">
      <div className="flex items-start justify-between gap-3"><p className="text-sm leading-relaxed">{t.sampleExplorer.loadError}</p><button type="button" onClick={props.onClose} aria-label={t.sampleExplorer.close} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg focus-visible:outline focus-visible:outline-2"><X aria-hidden="true" className="h-4 w-4" /></button></div>
      <a href="/vzorec.pdf" download="vzorec-porocila-nReport.pdf" className="mt-2 inline-flex min-h-11 items-center text-sm font-medium text-primary underline underline-offset-4">{t.pdfPreview.download}</a>
    </div>
  }><Suspense fallback={
    <div className="fixed bottom-5 left-[50dvw] z-[70] flex w-max max-w-[calc(100dvw-2rem)] -translate-x-1/2 items-center gap-3 rounded-xl border bg-background p-3 shadow-lg">
      <span role="status" className="flex items-center gap-2 text-sm"><Loader2 aria-hidden="true" className="h-4 w-4 motion-safe:animate-spin" />{t.sampleExplorer.loading}</span>
      <button type="button" onClick={props.onClose} aria-label={t.sampleExplorer.close} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg focus-visible:outline focus-visible:outline-2"><X aria-hidden="true" className="h-4 w-4" /></button>
    </div>
  }><SampleReportDialog {...props} /></Suspense></ErrorBoundary>;
}
